    export const ROLE = {
    ADMIN: 1,
    USER: 2,
    GUARD: 3,
    FINANCE: 4,
    TOUR_GUIDE: 5,
};
